<div class="profile__wrapper">
  <i
    class="icon-pencil"
    [class.grey]="isEditable"
    *ngIf="ableToEdit"
    (click)="switchEdit($event)"
  ></i>
  <div class="row">
    <div class="col-7">
      <fieldset [disabled]="!isEditable" class="form__fieldset">
        <div class="col-sm-6">
          <div
            class="hr-data"
            [class.hr-nodata]="!dataCertPerformanceReview.length"
          >
            <div>Performance review</div>
            <button
              class="button button__add--normal"
              type="button"
              (click)="addNewPerformanceReview()"
              *ngIf="dataCertPerformanceReview.length === 0 && isEditable"
            ></button>
            <div class="mt-16">
              <app-table
                *ngIf="dataCertPerformanceReview.length"
                [showEditFields]="isEditable"
                [tableType]="typeOfTable"
                [headers]="headersCertPerformanceReview"
                [content]="dataCertPerformanceReview"
                [editOnlyLastRow]="true"
                [editMenu]="'icon'"
                (rowAction)="
                  performanceReviewTableActions($event)
                "
              ></app-table>
            </div>
          </div>
          <div class="hr-data" [class.hr-nodata]="!dataCertPromotion.length">
            <div>Promotion</div>
            <button
              type="button"
              *ngIf="dataCertPromotion.length === 0 && isEditable"
              class="button button__add--normal"
              (click)="addNewPromotion()"
            ></button>
            <div class="mt-16">
              <app-table
                *ngIf="dataCertPromotion.length"
                [showEditFields]="isEditable"
                [tableType]="typeOfTable"
                [headers]="headersCertPromotion"
                [content]="dataCertPromotion"
                [editOnlyLastRow]="true"
                [editMenu]="'icon'"
                (rowAction)="
                  promotionTableActions($event)
                "
              ></app-table>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="col-2">
      <button
        class="button button__lightblue value__button"
        (click)="openValuesAndHobbies()"
      >
        Values and hobbies
      </button>
    </div>
  </div>
  <fieldset [disabled]="!isEditable" class="form__fieldset">
    <div class="row">
      <div class="hr-nodata">
        <div>One-to-one</div>
        <button
          *ngIf="isEditable"
          type="button"
          class="button button__add--normal"
          (click)="addNewOneToOne()"
        ></button>
      </div>
      <div class="mt-16 one-to-one-table">
        <app-table
          *ngIf="dataCertOneToOne.length"
          [showEditFields]="isEditable"
          [tableType]="typeOfTable"
          [headers]="headersCertOneToOne"
          [content]="dataCertOneToOne"
          [editMenu]="'icon'"
          [showPlusIcon]="false"
          (rowAction)="oneToOneTableActions($event)"
        ></app-table>
      </div>
    </div>
  </fieldset>
  <fieldset class="form__fieldset">
    <div class="row">
      <div
        class="hr-data col-9"
        [class.hr-nodata]="!dataCertWorkingPeriods.length"
      >
        <div>Working periods</div>
        <div class="mt-16">
          <app-table
            *ngIf="dataCertWorkingPeriods.length"
            [tableType]="typeOfTable"
            [headers]="headersCertWorkingPeriods"
            [content]="dataCertWorkingPeriods"
          ></app-table>
        </div>
      </div>
    </div>
  </fieldset>
</div>
